import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-win-tumbler',
  templateUrl: './win-tumbler.component.html',
  styleUrls: ['./win-tumbler.component.scss']
})
export class WinTumblerComponent implements OnInit {

  step = 1;

  constructor() { }

  ngOnInit(): void {
  }

}
